import { FaExternalLinkAlt } from "react-icons/fa";


const Footer = () => {
  return (
    <div className="w-full ">

      <div className="bg-black  font-poppins flex flex-wrap justify-center p-4 gap-8 md:gap-10 md:p-10">
        <p>About Us</p>
        <p>FAQs</p>
        <p>News</p>

        <p>Contact Us</p>
        <p>Career</p>
        <p>
          <a
            href="https://github.com/Hrithik06/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2"
          >
            GitHub <FaExternalLinkAlt />
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
